import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PacientesComponent } from './components/pacientes/pacientes.component';
import { CitasMedicasComponent } from './components/citas-medicas/citas-medicas.component';
import { BaseModule } from '../base/base.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { RegistroPacienteComponent } from './components/registro-paciente/registro-paciente.component';
import { OrderModule } from 'ngx-order-pipe';
import { TratamientosComponent } from './components/tratamientos/tratamientos.component';
import { KardexPacienteComponent } from './components/kardex-paciente/kardex-paciente.component';
import { RecetasComponent } from './components/recetas/recetas.component';
import { LaboratoriosComponent } from './components/laboratorios/laboratorios.component';
import { RegistroLaboratorioComponent } from './components/registro-laboratorio/registro-laboratorio.component';
import { VistaLaboratorioComponent } from './components/vista-laboratorio/vista-laboratorio.component';
import { ResultadoLaboratorioComponent } from './components/resultado-laboratorio/resultado-laboratorio.component';
import { FullCalendarModule } from '@fullcalendar/angular';

@NgModule({
  declarations: [
    PacientesComponent,
    CitasMedicasComponent,
    RegistroPacienteComponent,
    TratamientosComponent,
    KardexPacienteComponent,
    RecetasComponent,
    LaboratoriosComponent,
    RegistroLaboratorioComponent,
    VistaLaboratorioComponent,
    ResultadoLaboratorioComponent,
  ],
  imports: [
    CommonModule,
    BaseModule,
    FormsModule,
    NgbModule,
    OrderModule,
    NgxBootstrapMultiselectModule,
    FullCalendarModule
  ],
    exports:[
      
    ]
})
export class MedicinaModule { }
